module.exports = __webpack_public_path__ + "static/media/29ADMSPC39.27b410ea.jpg";